module.exports = __webpack_public_path__ + "img/[皱眉].7261059a.svg";